(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_search_header"] && !Shopify.designMode) return;
  try {
    (function(){

const targetSummary = document.querySelector('.main-collection-grid');

if (targetSummary) {
    const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
            if (mutation.type === 'characterData' || mutation.type === 'childList') {
                const updatedText = targetSummary.querySelector('.gf-summary b').textContent;
                // Replicate the text to your custom display element
                document.querySelectorAll('.search-header__title span').forEach(el => {
                    el.textContent = updatedText;
                });
            }
        }
    });

    // Configuration: Watch for any text or structural changes inside the div
    observer.observe(targetSummary, { childList: true, characterData: true, subtree: true });
}

new Swiper('.search-header__blocks', {
    slidesPerView: 'auto',
    speed: 400,
    freeMode: {
        enabled: true,
        sticky: true,
        momentumRatio: 0.8,
    },
});

})()
  } catch(e) { console.error(e); }
})();

})();
